import React from "react";
import Formnav from "./FormNav";
import Formfooter from "./FormFooter";
import ForgetEmailForm from "./ForgetEmailForm";
import { Constants } from "../../CommonMethhods/Constants";

function ForgetEmail() {
  return (
    <>
      <title>{Constants.Recover_UserId}</title>
      <div className="login-page">
        <div className="login-content h-100">
          <div className="container h-100">
            <div className="row h-100">
              {/* <Formnav /> */}
              <div className="ipad-bottom m-auto forget-email">
                <ForgetEmailForm />
                <Formfooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetEmail;
